<template>
    <div class="json-viewer">
        <b-tabs content-class="mt-0" v-model="activeTab">
            <b-tab title="Text">
                {{ data }}
            </b-tab>
            <b-tab title="JSON" v-if="jsonData">
                <vue-json-pretty :data="jsonData"
                                 :deep="3"
                                 :showLength="true"
                                 :highlightSelectedNode="false"
                                 :selectOnClickNode="false"></vue-json-pretty>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
    import VueJsonPretty from 'vue-json-pretty'

    export default {
        name: 'JsonViewer',
        components: {
            VueJsonPretty
        },
        props: ['data'],
        data() {
            return {
                jsonData: null,
                activeTab: 0
            }
        },
        mounted: function () {
            try {
                if (this.data.length < 10000) {
                    this.jsonData = JSON.parse(this.data);
                    this.activeTab = 1;
                }
            } catch {
                this.activeTab = 0;
            }
        },
        watch: {
            data(val) {
                try {
                    if (this.data.length < 10000) {
                        this.jsonData = JSON.parse(val);
                        this.activeTab = 1;
                    }
                } catch {
                    this.activeTab = 0;
                }
            }
        }
    }
</script>

<style scoped>
    textarea {
        background-color: transparent !important;
        box-shadow: none !important;
        resize: none;
        /*overflow: hidden;*/
        color: #000;
    }

    .json-viewer >>> .tab-content {
        max-height: 200px;
        overflow: auto
    }
</style>

